import React, { useState } from "react";
import { toast } from "sonner";
import FilePreviewSheet, { canPreview } from "@/components/files/FilePreviewSheet";
import { chunkedUpload } from "@/lib/chunkedUpload";

export default function TaskActivity({ activity, actHasMore, loadOlderActivity, loadingOlder, taskId, onMarkupSaved }) {
  const [preview, setPreview] = useState(null);
  if (!activity.length) return null;

  const saveMarkup = taskId ? async (markedFile) => {
    await chunkedUpload({ base: `/tasks/${taskId}/attachments`, file: markedFile });
    onMarkupSaved?.();
    toast.success("Marked-up version saved");
  } : undefined;

  return (
    <div>
      <label className="text-xs font-semibold uppercase tracking-wider text-zinc-500 mb-2 block">Activity</label>
      <div className="relative pl-4 space-y-3 max-h-56 overflow-y-auto border-l border-zinc-200" data-testid="activity-timeline">
        {actHasMore && (
          <button type="button" onClick={loadOlderActivity} disabled={loadingOlder}
            className="text-xs font-medium text-zinc-500 hover:text-zinc-900 transition-colors disabled:opacity-50"
            data-testid="load-older-activity">
            {loadingOlder ? "Loading…" : "Load older activity"}
          </button>
        )}
        {activity.map((a) => (
          <div key={a.activity_id} className="relative" data-testid={`activity-${a.activity_id}`}>
            <span className="absolute -left-[21px] top-1 h-2 w-2 rounded-full bg-zinc-300" />
            <p className="text-xs text-zinc-500">
              <span className="font-semibold text-zinc-800">{a.actor_name}</span>
              {a.kind === "comment" ? " commented" : a.kind === "attachment" && a.meta ? (
                <>
                  {" attached "}
                  <button type="button" onClick={() => setPreview(a.meta)}
                    data-testid={`activity-file-${a.activity_id}`}
                    className="font-medium text-zinc-700 hover:underline">
                    {a.meta.original_filename}
                  </button>
                </>
              ) : ` ${a.text}`}
              <span className="text-zinc-400 ml-1">· {new Date(a.at).toLocaleString()}</span>
            </p>
            {a.kind === "comment" && <p className="text-sm text-zinc-700 whitespace-pre-wrap break-words">{a.text}</p>}
          </div>
        ))}
      </div>
      <FilePreviewSheet file={preview} onClose={() => setPreview(null)} onSaveMarkup={saveMarkup} />
    </div>
  );
}
